import React, { useContext } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
// import cayeshLogo from 'assets/images/salasel-logo.svg';
import cayeshLogo from 'assets/images/cayesh-logo.png';

import './sidbar.scss';
import { checkPermission, loadState } from 'utils';
import { useTranslation } from 'react-i18next';
import { LayoutConteact } from '../context/appLayout';

const SidebarLayout = () => {
	const { isSidbarCollapsed } = useContext(LayoutConteact);
	const { t } = useTranslation();

	const { pathname } = useLocation();

	const STORAGE_KEY = 'cayesh_user_loggged';
	const storedUser = loadState(STORAGE_KEY);
	const { category } = storedUser.user;
	const { permissions } = storedUser;
	const { currentCompany } = storedUser;
	return (
		<aside
			className={`d-flex flex-column justify-content-between sidebar-layout no-print ${
				isSidbarCollapsed ? 'sidebar-collapse' : ''
			} sidenav-container`}
		>
			<div className={'sidebar-menu'}>
				<div className='nav--header px-4 mb-2'>
					{/* <img src='/bank_logo.png' alt='' className='img-fluid w-auto' /> */}
					<img src={cayeshLogo} alt='' className='img-fluid w-auto' />
				</div>
				<div className='nav--content'>
					<nav className=''>
						<ul className='navbar-nav'>
							<li className='nav-item'>
								<NavLink
									className={state => (state.isActive ? 'nav-link ps-1 active' : 'nav-link ps-1')}
									aria-current='page'
									to='/dashboard'
								>
									{/* <i className='icon-dashboard mx-4'></i> */}
									<i className='bi bi-house-door-fill sidebar--icon mx-3'></i>
									{t('Dashboard')}
								</NavLink>
							</li>

							{category !== 'company' && (
								<>
									{checkPermission(permissions, 'admin-reports-read') && (
										<li className='nav-item'>
											<NavLink
												className={state => (state.isActive ? 'nav-link ps-1 active' : 'nav-link ps-1')}
												aria-current='page'
												to='/reports'
											>
												{/* <i className='icon-dashboard mx-4'></i> */}
												<i className='bi bi-graph-up-arrow sidebar--icon mx-3'></i>
												{t('Reports')}
											</NavLink>
										</li>
									)}
									{checkPermission(permissions, 'admin-finance-request-read') && (
										<li className='nav-item'>
											<NavLink
												className={state => (state.isActive ? 'nav-link ps-1 active' : 'nav-link ps-1')}
												aria-current='page'
												to='/financing-requests'
											>
												{/* <i className='icon-fin-req mx-4'></i> */}
												<i className='bi bi-cash sidebar--icon mx-3'></i>
												{t('fin-req')}
											</NavLink>
										</li>
									)}
									{checkPermission(permissions, 'transaction-read') && (
										<li className='nav-item'>
											<NavLink
												aria-current='page'
												to='/transactions'
												className={state => (state.isActive ? 'nav-link ps-1 active' : 'nav-link ps-1')}
											>
												{/* <i className='icon-trans mx-4'></i> */}
												<i className='bi bi-arrow-left-right sidebar--icon mx-3'></i>
												{t('Transactions')}
											</NavLink>
										</li>
									)}
									{checkPermission(permissions, 'company-read') && (
										<li className='nav-item'>
											<NavLink
												className={state => (state.isActive ? 'nav-link ps-1 active' : 'nav-link ps-1')}
												aria-current='page'
												to='/companies'
											>
												{/* <i className='icon-comp mx-4'></i> */}
												<i className='bi bi-building-fill sidebar--icon mx-3'></i>
												{t('Companies')}
											</NavLink>
										</li>
									)}
									{checkPermission(permissions, 'program-read') && (
										<li className='nav-item'>
											<NavLink
												className={state => (state.isActive ? 'nav-link ps-1 active' : 'nav-link ps-1')}
												aria-current='page'
												to='/programs'
											>
												{/* <i className='icon-program mx-4'></i> */}
												<i className='bi bi-building-fill-gear sidebar--icon mx-3'></i>
												{t('Programs')}
											</NavLink>
										</li>
									)}
								</>
							)}

							<li className='nav-item'>
								<div
									className={`'active nav-link w-100  justify-content-center my-2'
											
									}`}
									// style={{ marginBottom: '10px', marginTop: '10px' }}
								>
									{/* <i className='icon-gear mx-4'></i> */}
									<div className='sidebar--sub--menu d-flex align-items-center w-100'>
										<span className='flex-grow-1 dropdown-link'>{t('Settings')}</span>
										<div className='sidebar--divider'></div>
									</div>

									{/* <i className='bi bi-chevron-up ms-1'></i> */}
								</div>
								<div>
									<ul className='custom-dropdown-menu '>
										{category !== 'company' && (
											<>
												{checkPermission(permissions, 'admin-bank-account-read') && (
													<NavLink
														className={state =>
															state.isActive ? 'nav-link ps-1 sub-active fs-6 py-1' : 'nav-link ps-1 fs-6 py-1'
														}
														aria-current='page'
														to='/bank-accounts'
													>
														<i className='bi bi-bank2  sidebar--icon mx-3'></i>
														{t('bank-accounts')}
													</NavLink>
												)}
												{checkPermission(permissions, 'user-read') && (
													<NavLink
														className={state =>
															state.isActive ? 'nav-link ps-1 sub-active fs-6 py-1' : 'nav-link ps-1 fs-6 py-1'
														}
														aria-current='page'
														to='/users'
													>
														<i className='bi bi-people-fill sidebar--icon mx-3'></i>
														{t('Users')}
													</NavLink>
												)}
												{checkPermission(permissions, 'role-read') && (
													<NavLink
														className={state =>
															state.isActive ? 'nav-link ps-1 sub-active fs-6 py-1' : 'nav-link ps-1 fs-6 py-1'
														}
														aria-current='page'
														to='/permissions'
													>
														<i className='bi bi-person-fill-lock sidebar--icon mx-3'></i>
														{'Roles And Permissions'}
													</NavLink>
												)}
												{/* {checkPermission(permissions, 'admin-settings-read') && (
													<NavLink
														className={state =>
															state.isActive ? 'nav-link ps-1 sub-active fs-6 py-1' : 'nav-link ps-1 fs-6 py-1'
														}
														aria-current='page'
														to='/reports'
													>
														{t('Reports')}
													</NavLink>
												)} */}

												{checkPermission(permissions, 'admin-settings-read') && (
													<NavLink
														className={state =>
															state.isActive ? 'nav-link ps-1 sub-active fs-6 py-1' : 'nav-link ps-1 fs-6 py-1'
														}
														aria-current='page'
														to='/admins-general-settings'
													>
														<i className='bi bi-gear-fill sidebar--icon mx-3'></i>
														{t('General-Settings')}
													</NavLink>
												)}

												<NavLink
													className={state =>
														state.isActive ? 'nav-link ps-1 sub-active fs-6 py-1' : 'nav-link ps-1 fs-6 py-1'
													}
													aria-current='page'
													to='lookups'
												>
													<i className='bi bi-sliders2 sidebar--icon mx-3'></i>
													{'Others'}
												</NavLink>
											</>
										)}
									</ul>
								</div>
							</li>
						</ul>
						{/* <div className='bottom-sidebar bottom-sid '>
						<span>{t('powered-by')}:</span>
						<img src={cayeshLogo} alt='' className='img-fluid' />
					</div> */}
					</nav>
				</div>
			</div>
			{/* <div className='nav--footer'>
				<span className='mb-2'>{t('powered-by')}:</span>
				<img src={cayeshLogo} />
			</div> */}
		</aside>
	);
};

export default SidebarLayout;
